import { render, staticRenderFns } from "./CreateTicket.vue?vue&type=template&id=c3d4e846&"
import script from "./CreateTicket.vue?vue&type=script&lang=js&"
export * from "./CreateTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListItem } from 'vuetify/lib'
import { VListItemContent } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VDialog,VIcon,VList,VListItem,VListItemContent,VRow,VSelect,VSpacer,VTextField,VTextarea,VToolbar,VToolbarItems,VToolbarTitle})
